export const CUSTOMER_SERVICE = "Customer Service";
export const STANDARD_USER = "StandardUser";
export const CUSTOMER_USER_ACCOUNTING = "CustomerUserAccounting";
export const CUSTOMER_USER_ORDER_MANAGE = "CustomerUserOrderManage";
export const ADMINISTRATOR = "Administrator";
export const USER_ACCOUNT_MANAGER = "UserAccountManager";
export const MULTI_ORGANIZATION_CUSTOMER_USER = "MultiOrganizationCustomerUser";
